export const selectCurrentLang = (s) => s.currentLang;
//# sourceMappingURL=selectors.js.map